import type { FaireProductEntity } from "../../entity_types/product";

export const p_6qdsjvg6y6: FaireProductEntity = {
  token: "p_6qdsjvg6y6",
  type: "product",
  name: "Cutie Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/eff07429b66ddc3bcabbd61c8d1403cf192ab4d51a7f139f74ce96798b8ba719.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8a117cb632cbc99b24b2b2090e260d5c2f9f4c2c07010cf12e6cc3c584c0c436.jpeg",
    "https://cdn.faire.com/fastly/33b48fd1b375639ccb18d92b8a294e515aa6281d37295b1d21d3ff09dc58b290.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/9aec584b9dbbb4e280e9a1b785ed4e7def14a1510d68ba999c9ade340cd3d7fd.jpeg",
    "https://cdn.faire.com/fastly/594a9cf688c258310bb064614089ed040d25152f1c622bd20c43278872cf685e.jpeg",
    "https://cdn.faire.com/fastly/deefc292c1e9c4cdbd226b5b0e7a2d4feaf5f22f17096f63e53314980a498869.jpeg",
    "https://cdn.faire.com/fastly/5050542d83ffd07fca490536204e1dde416ebf214d20741bc8d1717615545537.jpeg"
  ],
  priceDollars: 6.75,
  description: "Sweet, simple, and a little smug about it. These socks know they’re cuties—and so do you. 💅\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:29.787Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
